import { validExtensions } from "../pages/Products/EditItem/Constants";

const getFileType = (fileName: string) => {
    const validImageExtensions = new Set([
      validExtensions.jpg,
      validExtensions.jpeg,
      validExtensions.png,
      validExtensions.tiff,
      validExtensions.tif
    ]);

    const validPDFExtensions = new Set([
      validExtensions.pdf,
    ]);
    const fileExtension = fileName.includes(".") ? fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase() : "folder";
    
    const isImage = validImageExtensions.has(fileExtension);
    const isPdf = validPDFExtensions.has(fileExtension)
    const isFolder = fileExtension === "folder";
    return { fileExtension, isImage, isPdf, isFolder};
};

export default getFileType;